<script lang="ts">
import { defineComponent } from 'vue';
import { AisRefinementList } from 'vue-instantsearch/vue3/es';

// Directives
import dropdown from '@vue-directives/dropdown';

export default defineComponent({
  components: {
    AisRefinementList,
  },
  directives: {
    dropdown,
  },
  props: {
    label: {
      type: String,
      required: true,
    },
    attribute: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      isActive: false,
    };
  },
});
</script>
<template>
  <div v-dropdown class="dropdown group relative">
    <button
      aria-expanded="false"
      :aria-controls="`dropdown-${attribute}-menu`"
      class="dropdown-trigger flex min-h-10 w-full items-center justify-between gap-x-3 border-b-[1.5px] border-secondary-500 px-2 text-body-md text-neutral-400"
      type="button"
    >
      {{ label }}
      <svg
        width="13"
        height="12"
        viewBox="0 0 13 12"
        fill="none"
        class="text-[#1e201e]"
        aria-hidden="true"
      >
        <path
          d="M11.5913 5.42069L6.17062 10.8414L0.749925 5.42069"
          stroke="currentColor"
          stroke-width="1.5"
          stroke-linecap="round"
        />
      </svg>
    </button>

    <div
      :id="`dropdown-${attribute}-menu`"
      class="dropdown-menu absolute top-full left-0 z-1 mt-2 hidden min-w-60 rounded-b-lg bg-white text-body-md shadow-lg group-[.open]:block"
    >
      <ais-refinement-list
        :attribute="attribute"
        :limit="100"
        :sort-by="['name:asc']"
        :class-names="{
          'ais-RefinementList-count': 'hidden',
          'ais-RefinementList-checkbox': 'mr-3',
          'ais-RefinementList-label': 'block px-4 py-3',
        }"
      />
    </div>
  </div>
</template>
